import { collectData } from '@caresource/watchtower-js';
import { watchtower } from '../config';
import { useCallback } from 'react';
import ky from 'ky';
import { EventBase } from '../types/AnalyticsTypes.d';

export const useAnalytics = () => {

    const logEvent = useCallback(
        (event) => {
            if (!(event instanceof EventBase)) {
                throw Error('Unknown event type')
            }

            const data = collectData({
                cookieDomain: watchtower.cookieDomain
            });

            const submission = {
                event: event,
                data: data
            };

            try {
                ky.post('/api/analyticslogger', {
                    headers: {
                        "Content-Type": "application/json",
                    },
                    json: submission,
                    https: { rejectUnauthorized: false }, //for the internal SSL errors
                    retry: { limit: 0 },
                })
            } catch (err) {
                console.debug(err)
            }
        }, []
    );

    return {logEvent};

}